module.exports = __webpack_public_path__ + "media/img/payment-methods/alipay-75d8ca63199bcecb3bd2b1b3c560e944.svg";